import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-deactivate-minus-icon',
    templateUrl: './deactivate-minus-icon.component.html',
    styleUrls: ['./deactivate-minus-icon.component.scss'],
    standalone: false
})
export class DeactivateMinusIconComponent implements OnInit {
  param: any;
  constructor() { }

  ngOnInit() {
  }

}
